var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreholdsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 71,
    viewBox: "0 0 80 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_1028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12H37.94C38.67 17.08 43.04 21 48.32 21C53.6 21 57.97 17.08 58.7 12H78.32C79.15 12 79.82 11.33 79.82 10.5C79.82 9.67 79.15 9 78.32 9H58.7C57.97 3.92 53.6 0 48.32 0C43.04 0 38.67 3.92 37.94 9H1.5C0.67 9 0 9.67 0 10.5C0 11.33 0.67 12 1.5 12ZM48.32 3C52.46 3 55.82 6.36 55.82 10.5C55.82 14.64 52.46 18 48.32 18C44.18 18 40.82 14.64 40.82 10.5C40.82 6.36 44.18 3 48.32 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32 34H37.7C36.97 28.92 32.6 25 27.32 25C22.04 25 17.67 28.92 16.94 34H1.5C0.67 34 0 34.67 0 35.5C0 36.33 0.67 37 1.5 37H16.94C17.67 42.08 22.04 46 27.32 46C32.6 46 36.97 42.08 37.7 37H78.32C79.15 37 79.82 36.33 79.82 35.5C79.82 34.67 79.15 34 78.32 34ZM27.32 43C23.18 43 19.82 39.64 19.82 35.5C19.82 31.36 23.18 28 27.32 28C31.46 28 34.82 31.36 34.82 35.5C34.82 39.64 31.46 43 27.32 43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32 59H58.7C57.97 53.92 53.6 50 48.32 50C43.04 50 38.67 53.92 37.94 59H1.5C0.67 59 0 59.67 0 60.5C0 61.33 0.67 62 1.5 62H37.94C38.67 67.08 43.04 71 48.32 71C53.6 71 57.97 67.08 58.7 62H78.32C79.15 62 79.82 61.33 79.82 60.5C79.82 59.67 79.15 59 78.32 59ZM48.32 68C44.18 68 40.82 64.64 40.82 60.5C40.82 56.36 44.18 53 48.32 53C52.46 53 55.82 56.36 55.82 60.5C55.82 64.64 52.46 68 48.32 68Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_1028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.82,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreholdsIcon);
export default __webpack_public_path__ + "static/media/threholds-icon.b5d4a7cbbd5b12f462b785eb972449ce.svg";
export { ForwardRef as ReactComponent };